require('new_design/common/main_slider');
